import store from "store";

const fetchUserData = async ($config) => {
  try {
    const res = await fetch(
      `${$config.apiUrl}/users/get_or_create?user_type=${store.get(
        "userType"
      )}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${store.get("accessToken")}`,
        },
      }
    );
    const data = await res.json();

    console.log("fetchUserData data", data);

    const value = {
      subscribed: data.has_paid,
      endTimestamp: data.expires_at,
      userType: data.user_type,
      tier: data.subscription_tier,
      uuid: data.uuid,
    };

    return value;
  } catch (error) {
    console.error(error);
  }
};

export default fetchUserData;
